(function () {
  if (window.__thMegaDrawerInit) return;
  window.__thMegaDrawerInit = true;

  var root = document.querySelector("[data-th-mega-drawer]");
  if (!root) return;

  var drawer = document.querySelector("[data-th-mega-drawer-panel]");
  if (!drawer) return;

  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  // Only drawer openers (buttons with data-menu-id) — not campaign links
  var triggers = root.querySelectorAll(".th-mega-drawer-nav__trigger[data-menu-id]");
  var panel = drawer.querySelector("[data-th-mega-panel]");
  var headerSection = document.querySelector(".shopify-section--header");
  var menuData = [];
  var activeMenuId = null;
  var activeSubId = null;
  var maintainTimer = null;
  var closePanelTimer = null;
  var closeRestoreTimer = null;
  var CLOSE_MS = 380;
  var BORDER_OUT_MS = 280;

  var jsonEl = root.querySelector("[data-th-mega-menu-json]");
  if (!jsonEl) jsonEl = document.querySelector("[data-th-mega-menu-json]");

  try {
    if (!jsonEl) throw new Error("missing menu json");
    menuData = JSON.parse(jsonEl.textContent);
  } catch (e) {
    console.warn("[th-mega-drawer] menu JSON parse failed", e);
    return;
  }

  function getXHeader() {
    return document.querySelector("x-header.header, x-header");
  }

  function isOpen() {
    return drawer.classList.contains("is-open");
  }

  function isClosing() {
    return drawer.classList.contains("is-closing");
  }

  function cancelClose() {
    if (closePanelTimer) {
      window.clearTimeout(closePanelTimer);
      closePanelTimer = null;
    }
    if (closeRestoreTimer) {
      window.clearTimeout(closeRestoreTimer);
      closeRestoreTimer = null;
    }
    drawer.classList.remove("is-closing");
    document.documentElement.classList.remove("th-mega-drawer-closing");
    if (!drawer.classList.contains("is-open")) {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
    }
  }

  function clearPanel() {
    if (!panel) return;
    panel.hidden = true;
    panel.classList.remove("has-columns");
    panel.innerHTML = "";
  }

  function revealHeader() {
    var xHeader = getXHeader();
    if (xHeader) {
      xHeader.classList.remove("is-hidden");
      xHeader.classList.add("th-mega-drawer-menu-open");
      document.documentElement.style.setProperty("--header-is-visible", "1");
    }
    if (headerSection) headerSection.classList.add("th-mega-drawer-header-active");
  }

  function headerBottom() {
    var xHeader = getXHeader();
    if (xHeader) {
      var hr = xHeader.getBoundingClientRect();
      if (hr.bottom > 1) return Math.round(hr.bottom);
    }
    var header = document.querySelector(".shopify-section--header");
    if (header) {
      var sr = header.getBoundingClientRect();
      if (sr.bottom > 1) return Math.round(sr.bottom);
    }
    return 80;
  }

  function pinDrawerTop() {
    if (
      isOpen() ||
      isClosing() ||
      document.documentElement.classList.contains("th-mega-drawer-open")
    ) {
      revealHeader();
    }
    document.documentElement.style.setProperty("--th-mega-drawer-top", headerBottom() + "px");
  }

  function applyDrawerBackground() {
    document.documentElement.style.setProperty("--th-mega-drawer-bg", "rgb(255, 255, 255)");
  }

  function clearDrawerBackground() {
    document.documentElement.style.removeProperty("--th-mega-drawer-bg");
  }

  function maintainHeaderState() {
    if (!isOpen() && !isClosing()) {
      stopMaintain();
      return;
    }

    revealHeader();
    pinDrawerTop();
  }

  function restoreHeaderState() {
    if (headerSection) headerSection.classList.remove("th-mega-drawer-header-active");

    var xHeader = getXHeader();
    if (xHeader) xHeader.classList.remove("th-mega-drawer-menu-open");

    clearDrawerBackground();
    document.documentElement.classList.remove("th-mega-drawer-open");
    document.body.classList.remove("th-mega-drawer-open");
  }

  function startMaintain() {
    stopMaintain();
    maintainHeaderState();
    maintainTimer = window.setInterval(maintainHeaderState, 200);
  }

  function stopMaintain() {
    if (maintainTimer) {
      window.clearInterval(maintainTimer);
      maintainTimer = null;
    }
  }

  function setDrawerOpenState(on) {
    if (on) {
      applyDrawerBackground();
      document.documentElement.classList.add("th-mega-drawer-open");
      document.body.classList.add("th-mega-drawer-open");
      maintainHeaderState();
      startMaintain();
      return;
    }

    stopMaintain();
    restoreHeaderState();
  }

  function findMenu(id) {
    return menuData.find(function (m) {
      return m.id === id;
    });
  }

  function findSubItem(menu, subId) {
    return (menu.items || []).find(function (i) {
      return i.id === subId;
    });
  }

  function renderSubLinks(groups) {
    var html = "";
    groups.forEach(function (group) {
      (group.items || []).forEach(function (item) {
        html +=
          '<li><a class="th-mega-drawer__link" href="' +
          item.url +
          '">' +
          item.title +
          "</a></li>";
      });
    });
    return html;
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderTiles(items) {
    var html = '<div class="th-mega-drawer__tiles">';
    (items || []).forEach(function (item, i) {
      var src = item.image || item.imageFallback || "";
      var fb = item.imageFallback && item.imageFallback !== src ? item.imageFallback : "";
      var onerr = fb ? ' onerror="this.onerror=null;this.src=\'' + escapeHtml(fb) + '\'"' : "";
      var eager = i < 8;
      html +=
        '<a class="th-mega-drawer__tile" href="' +
        escapeHtml(item.url) +
        '">' +
        '<span class="th-mega-drawer__tile-media">' +
        '<img src="' +
        escapeHtml(src) +
        '" alt="' +
        escapeHtml(item.title) +
        '" width="360" height="480"' +
        (eager ? ' loading="eager" fetchpriority="low"' : ' loading="lazy"') +
        ' decoding="async" draggable="false"' +
        onerr +
        ">" +
        "</span>" +
        '<span class="th-mega-drawer__tile-label">' +
        escapeHtml(item.title) +
        "</span></a>";
    });
    html += "</div>";
    return html;
  }

  function renderMainLinks(items) {
    var html = '<ul class="th-mega-drawer__list">';
    items.forEach(function (item) {
      if (item.groups) {
        html +=
          '<li><button type="button" class="th-mega-drawer__link th-mega-drawer__link--expandable" data-sub-id="' +
          item.id +
          '">' +
          item.title +
          "</button></li>";
      } else {
        html +=
          '<li><a class="th-mega-drawer__link" href="' +
          item.url +
          '">' +
          item.title +
          "</a></li>";
      }
    });
    html += "</ul>";
    return html;
  }

  function setSubColumn(subId) {
    if (!panel) return;
    var menu = findMenu(activeMenuId);
    if (!menu) return;

    var subCol = panel.querySelector("[data-th-mega-sub]");
    var mainCol = panel.querySelector("[data-th-mega-main]");
    if (!subCol || !mainCol) return;

    mainCol.querySelectorAll("[data-sub-id].is-active").forEach(function (btn) {
      btn.classList.remove("is-active");
    });

    if (!subId) {
      activeSubId = null;
      subCol.innerHTML = "";
      subCol.classList.remove("is-visible");
      return;
    }

    var item = findSubItem(menu, subId);
    if (!item || !item.groups) return;

    activeSubId = subId;
    subCol.classList.add("is-visible");
    subCol.innerHTML =
      '<ul class="th-mega-drawer__list">' + renderSubLinks(item.groups) + "</ul>";

    var activeBtn = mainCol.querySelector('[data-sub-id="' + subId + '"]');
    if (activeBtn) activeBtn.classList.add("is-active");
  }

  function bindMainHandlers() {
    if (!panel) return;

    panel.querySelectorAll("[data-sub-id]").forEach(function (btn) {
      btn.addEventListener("mouseenter", function () {
        setSubColumn(btn.getAttribute("data-sub-id"));
      });

      btn.addEventListener("focus", function () {
        setSubColumn(btn.getAttribute("data-sub-id"));
      });

      btn.addEventListener("click", function (e) {
        e.preventDefault();
      });
    });

    panel.querySelectorAll("[data-th-mega-main] .th-mega-drawer__link:not([data-sub-id])").forEach(function (link) {
      link.addEventListener("mouseenter", function () {
        setSubColumn(null);
      });
    });
  }

  function handleDrawerPanelLeave(e) {
    if (!panel || panel.contains(e.relatedTarget)) return;
    setSubColumn(null);
  }

  function closeCompetingPanels() {
    var searchDropdown = document.getElementById("headerSearchDropdown");
    if (searchDropdown && searchDropdown.getAttribute("aria-hidden") === "false") {
      searchDropdown.setAttribute("aria-hidden", "true");
      searchDropdown.removeAttribute("open");
      document.documentElement.classList.remove("th-search-open");
    }

    var searchInput = document.getElementById("headerInlineSearchInput");
    if (searchInput && document.activeElement === searchInput) {
      searchInput.blur();
    }

    if (!isOpen() && !isClosing()) {
      document.body.style.overflow = "";
    }

    var cartDrawer = document.getElementById("cart-drawer");
    if (cartDrawer && cartDrawer.hasAttribute("open")) {
      if (typeof cartDrawer.hide === "function") {
        cartDrawer.hide();
      } else {
        cartDrawer.removeAttribute("open");
      }
    }
  }

  function bindPanelWatchers() {
    var searchDropdown = document.getElementById("headerSearchDropdown");
    if (searchDropdown) {
      new MutationObserver(function () {
        if (!isOpen() && !isClosing()) return;
        if (searchDropdown.getAttribute("aria-hidden") === "false" || searchDropdown.hasAttribute("open")) {
          closeDrawer();
        }
      }).observe(searchDropdown, { attributes: true, attributeFilter: ["aria-hidden", "open"] });
    }

    var searchInput = document.getElementById("headerInlineSearchInput");
    if (searchInput) {
      searchInput.addEventListener("focus", function () {
        if (isOpen()) closeDrawer();
      });
    }

    var cartDrawer = document.getElementById("cart-drawer");
    if (cartDrawer) {
      cartDrawer.addEventListener("dialog:before-show", function () {
        if (isOpen() || isClosing()) closeDrawer();
      });
    }

    document.querySelectorAll('a[aria-controls="cart-drawer"]').forEach(function (link) {
      link.addEventListener("click", function () {
        if (isOpen()) closeDrawer();
      });
    });
  }

  function openMenu(menuId) {
    var menu = findMenu(menuId);
    if (!menu || !panel) return;

    if (activeMenuId === menuId && isOpen()) return;

    var wasOpen = isOpen();
    cancelClose();

    if (!wasOpen) closeCompetingPanels();

    activeMenuId = menuId;
    activeSubId = null;

    triggers.forEach(function (btn) {
      btn.classList.toggle("is-active", btn.dataset.menuId === menuId);
    });

    var isTiles = menu.layout === "tiles";
    drawer.classList.toggle("is-tiles", isTiles);

    var bodyHtml;
    if (isTiles) {
      bodyHtml = renderTiles(menu.items || []);
    } else {
      var viewAllHtml = "";
      if (menu.viewAll && menu.viewAll.url) {
        viewAllHtml =
          '<a class="th-mega-drawer__link th-mega-drawer__link--view-all" href="' +
          menu.viewAll.url +
          '">' +
          (menu.viewAll.title || "Összes megtekintése") +
          "</a>";
      }

      var mainHtml = renderMainLinks(menu.items || []);
      bodyHtml =
        '<div class="th-mega-drawer__columns">' +
        '<div class="th-mega-drawer__col" data-th-mega-main>' +
        mainHtml +
        viewAllHtml +
        "</div>" +
        '<div class="th-mega-drawer__col th-mega-drawer__col--sub" data-th-mega-sub></div>' +
        "</div>";
    }

    if (!wasOpen) {
      revealHeader();
      pinDrawerTop();
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      setDrawerOpenState(true);
      requestAnimationFrame(pinDrawerTop);
    } else {
      pinDrawerTop();
    }

    panel.hidden = false;
    panel.classList.toggle("has-columns", !isTiles);
    panel.classList.toggle("has-tiles", isTiles);
    panel.innerHTML =
      '<p class="th-mega-drawer__panel-title">' + escapeHtml(menu.title) + "</p>" + bodyHtml;

    if (!isTiles) bindMainHandlers();
  }

  function closeDrawer() {
    if ((!isOpen() && !isClosing()) || isClosing()) return;

    activeMenuId = null;
    activeSubId = null;

    triggers.forEach(function (btn) {
      btn.classList.remove("is-active");
    });

    pinDrawerTop();
    drawer.classList.remove("is-open");
    drawer.classList.add("is-closing");
    document.documentElement.classList.add("th-mega-drawer-closing");
    drawer.setAttribute("aria-hidden", "true");

    if (closePanelTimer) window.clearTimeout(closePanelTimer);
    if (closeRestoreTimer) window.clearTimeout(closeRestoreTimer);

    closePanelTimer = window.setTimeout(function () {
      clearPanel();
      closePanelTimer = null;
    }, CLOSE_MS);

    closeRestoreTimer = window.setTimeout(function () {
      drawer.classList.remove("is-closing");
      drawer.classList.remove("is-tiles");
      document.documentElement.classList.remove("th-mega-drawer-closing");
      setDrawerOpenState(false);
      closeRestoreTimer = null;
    }, CLOSE_MS + BORDER_OUT_MS);
  }

  triggers.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (activeMenuId === btn.dataset.menuId && isOpen()) {
        closeDrawer();
      } else {
        openMenu(btn.dataset.menuId);
      }
    });
  });

  if (panel) {
    panel.addEventListener("mouseleave", handleDrawerPanelLeave);
  }

  var backdrop = drawer.querySelector(".th-mega-drawer__backdrop");
  if (backdrop) {
    backdrop.addEventListener("click", closeDrawer);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen()) closeDrawer();
  });

  window.addEventListener("resize", pinDrawerTop);
  window.addEventListener("scroll", pinDrawerTop, { passive: true });
  document.addEventListener(
    "wheel",
    function (e) {
      if (!isOpen()) return;
      if (panel && panel.contains(e.target) && panel.scrollHeight > panel.clientHeight) return;
      e.preventDefault();
    },
    { passive: false }
  );
  bindPanelWatchers();
  pinDrawerTop();
})();
